import * as XLSX from 'xlsx';

export async function normalizeToCsvFile(file: globalThis.File): Promise<globalThis.File> {
    const name = file.name.toLowerCase();

    // CSV -> return as-is
    if (name.endsWith('.csv')) return file;

    // Excel -> convert to CSV File (first sheet)
    if (name.endsWith('.xlsx') || name.endsWith('.xls')) {
        const buffer = await file.arrayBuffer();
        const workbook = XLSX.read(buffer, { type: 'array' });

        if (!workbook.SheetNames.length) {
            throw new Error('Excel file has no sheets');
        }

        const sheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[sheetName];

        const csvText = XLSX.utils.sheet_to_csv(worksheet);

        const csvName = file.name.replace(/\.(xlsx|xls)$/i, '.csv');

        return new File([csvText], csvName, { type: 'text/csv' });
    }

    throw new Error('Unsupported file type. Upload CSV or Excel.');
}
